import { ReactElement } from 'react';

import { AppStoreButtons } from './AppStoreButtons';
import config from '../config/index.json';

export const MainHero = (): ReactElement => {
    const { mainHero, company } = config;
    const { headerLogo } = company;

    return (
        <>
            <svg
                className={'hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-background transform translate-x-1/2'}
                fill='currentColor'
                viewBox='0 0 100 100'
                preserveAspectRatio='none'
                aria-hidden='true'
            >
                <polygon points='50,0 100,0 50,100 0,100' />
            </svg>
            <main className='mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-10 lg:mt-10 lg:px-8 xl:mt-18'>
                <div className='sm:text-center lg:text-left'>
                    <div className='heroImgCenter'>
                        <img className='scale-75 md:scale-100' src={headerLogo} alt={company.name} />
                    </div>
                    <h1 className='text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl'>
                        <span className='block xl:inline'>{mainHero.title}<br /></span>
                        <span className={'block text-primary xl:inline'}>{mainHero.subtitle}</span>
                    </h1>
                    <p className='mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0'>
                        {mainHero.description}
                    </p>
                    <AppStoreButtons />
                </div>
            </main>
        </>
    );
};
